export default __webpack_public_path__ + "static/media/andes_a_la_costa_28.8c8adfa3.jpg";